import React, { useState } from 'react';
import axios from 'axios';

const HuggingFaceComponent = () => {
  const [input, setInput] = useState('');
  const [response, setResponse] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await axios.post(
        "https://api-inference.huggingface.co/models/gpt2",
        {
          inputs: input,
        },
        {
          headers: {
            Authorization: `Bearer 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`,
          },
        }
      );
      setResponse(result.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      setResponse('Error fetching data.');
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button type="submit">Submit</button>
      </form>
      <div>
        <h3>Response:</h3>
        <div>
        <h3>Response:</h3>
        <pre>{JSON.stringify(response, null, 2)}</pre>
      </div>
      </div>
    </div>
  );
};

export default HuggingFaceComponent;
